export const education = [
    {
        id: 1,
        degree: "Master of Business Administration (MBA)",
        Title: "Change-Management",
        year: "2008 / NCOI Business School"

    },
    {
        id: 2,
        degree: "HEAO Management Economie en Recht",
        Title: "Change-Management",
        year: "2001 / Hogeschool Leeuwarden"

    },
    {
        id: 3,
        degree: "Professional Coaching and Facilitating",
        Title: "Coaching Agile Teams",
        year: "2008 / Boston, Lyssa Adkins"

    },
    {
        id: 4,
        degree: "Scrum Master / Product Owner, SAFe, LeSS",
        Title: "Agile Education",
        year: "2008-2020"

    },
    {
        id: 5,
        degree: "FullStack Developer",
        Title: "FE HTML, CSS, JavaScript & React, Java",
        year: "2023 / Novi Hogeschool"

    },
]